module.exports = __webpack_public_path__ + "b07b5d8167d498b121837753d652e1c4.svg";